var yswSO = {};
(function($) {
	yswSO = {
		settings: {
			swatch_type: '',
			option_names: [],
			img_cdn_url: '',
			free_swatch_img_desktop: '',
			free_swatch_img_mobile: ''
		},
		set_preview_swatch_position: function(current_swatch) {

			// set position
			var swatch_ul_pos = current_swatch.closest('.ysw-swatch-options').find('ul.swatches').offset().top;
			var swatch_li_pos = current_swatch.offset().top;
			var this_li_height = current_swatch.height();
			var pos_difference = swatch_li_pos - swatch_ul_pos;
			var preview_div_height = current_swatch.closest('.ysw-swatch-options').find('.swatch-preview-window').height();

			//var viewport_height = $(window).height();
			//var distance_from_li_to_bottom = viewport_height - swatch_li_pos;

			var top_position = Math.round(pos_difference - ((preview_div_height - this_li_height) / 2));

			current_swatch.closest('.ysw-swatch-options').find('.swatch-preview-window').css('top', top_position + 'px');

		},
		update_preview_swatch_info: function(current_swatch) {

			// change preview info
	        var swatch_position = current_swatch.data('position');
	        var swatch_wrap_position = current_swatch.closest('.ysw-swatch-options').data('position');

	        eval('var this_swatch = yswSO.settings.swatch_data_' + swatch_wrap_position + '[' + swatch_position + ']');

	        // image
	        $('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window .swatch-img').html('<img src="' + this_swatch.image_url + '" alt="' + this_swatch.name + '">');

	        // name
	        $('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window .swatch-name').text(this_swatch.name);

	        // price
	        if(this_swatch.price_upcharge > 0) {
	        	if($('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window .swatch-upcharge').length > 0) {
	        		$('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window .swatch-upcharge').html('Add $' + this_swatch.price_upcharge);
	        	} else {
	        		$('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window').append('<div class="swatch-upcharge"> Add $' + this_swatch.price_upcharge + '</div>');
	        	}
			} else {
				$('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window .swatch-upcharge').remove();
			}

		},
		is_touch_device: function() {
			return 'ontouchstart' in window || navigator.maxTouchPoints;
		},
		custom_events: function() {

			// Fancybox
			$(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").fancybox({
			  afterShow: function( instance, slide ) {
			    // Image
			    $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-image-wrap')
			  }
			});

			if(yswSO.is_touch_device() && window.matchMedia('(pointer:fine)').matches === false) {

				$(document).on('click','.ysw-swatch-options .request-free-swatch-link a.mobile-swatch-link', function() {
					$.fancybox.open({
						src  : yswSO.settings.free_swatch_img_mobile,
						type : 'image'
					});
				})

				// no hover
				// use click

				$(document).click(function() {
				    $('.ysw-swatch-options.ysw-swatch-left').removeClass('show-preview-window');
				});

				$(document).on('click','.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")', function(e) {

					e.stopPropagation();

					$(this).closest('.ysw-swatch-options').find('ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
					$(this).addClass('selected');
					var position = Number($(this).data('position'));

					var swatch_position = $(this).closest('.ysw-swatch-options').data('position');
					eval('var this_dropdown = yswSO.settings.swatch_dropdown_' + swatch_position);
					eval('this_swatch_data = yswSO.settings.swatch_data_' + swatch_position);

					this_dropdown.val(this_swatch_data[position].option_val).trigger('change');
                  	this_dropdown[0].dispatchEvent(new Event('change'));

					yswSO.update_preview_swatch_info($(this));

					// Hide other preview panes
					$('.ysw-swatch-options').removeClass('show-preview-window');
					// show preview pane for this option
				    $(this).closest('.ysw-swatch-options').addClass('show-preview-window');

				    // scroll to swatch preview only in mobile
				    // under 768 pixels
				    // check for mobile menu button to cheeck if truly in mobile
				    if($('.menu_icons button').is(':visible')) {

				    	// remove ysw-swatch-left class if present
				    	// important if user changes device orientation without refreshing page
				    	$('.ysw-swatch-options.show-preview-window').removeClass('ysw-swatch-left');

				    	// remove top inline css
				    	$('.ysw-swatch-options .swatch-preview-window').removeAttr('style');

				    	$.fancybox.open({
							src  : '.ysw-swatch-options.show-preview-window .swatch-preview-window',
							type : 'inline',
							opts : {
								smallBtn: false,
								afterShow: function( instance, slide ) {
								    $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .swatch-preview-window')
								}
							}
						});

					/*    if($('.nav-bar.sticky:visible').length > 0) {
					    	var sticky_header_height = $('.nav-bar.sticky:visible').height();
					    } else if($('header.sticky nav:visible').length > 0) {
					    	var sticky_header_height = $('header.sticky nav:visible').height();
					    } else {
					    	var sticky_header_height = 0;
					    }

					    // if top sitewide banner is showing
					    // add to offset
					    if($('.sumome-smartbar-popup').length > 0) {
					    	sticky_header_height = sticky_header_height + $('.sumome-smartbar-popup').height();
					    }

					    //console.log(sticky_header_height);

					    // scroll to preview
					    $('html, body').stop().animate({
							scrollTop: $(this).closest('.ysw-swatch-options').find('.swatch-preview-window').offset().top - sticky_header_height
						}, 400, function() {

							if(sticky_header_height == 0) {

							if($('.nav-bar.sticky:visible').length > 0) {
							    	sticky_header_height = $('.nav-bar.sticky:visible').height();
							    } else if($('header.sticky nav:visible').length > 0) {
							    	sticky_header_height = $('header.sticky nav:visible').height();
							    } else {
							    	sticky_header_height = 0;
							    }

							    // if top sitewide banner is showing
							    // add to offset
							    if($('.sumome-smartbar-popup').length > 0) {
							    	sticky_header_height = sticky_header_height + $('.sumome-smartbar-popup').height();
							    }

							    if(sticky_header_height > 0) {
								    // scroll again in case sticky header is now present
								    $('html, body').stop().animate({
										scrollTop: $(this).closest('.ysw-swatch-options').find('swatch-preview-window').offset().top - sticky_header_height
									}, 400);
								}

							}

						}); */

					} else {

						yswSO.set_preview_swatch_position($(this));

				    	$(this).closest('.ysw-swatch-options.show-preview-window').addClass('ysw-swatch-left');

					}


				})


			} else {

				$(document).on({
				    mouseenter: function () {
				        //stuff to do on mouse enter
				        //console.log('hover on');

				        yswSO.update_preview_swatch_info($(this));

						yswSO.set_preview_swatch_position($(this));

				        // show preview pane
				        $(this).closest('.ysw-swatch-options').addClass('show-preview-window');

				    },
				    mouseleave: function () {
				        //stuff to do on mouse leave
				        //console.log('hover off');

				        // hide preview pane
				        $(this).closest('.ysw-swatch-options').removeClass('show-preview-window');

				        // remove position
				        $(this).closest('.ysw-swatch-options').find('.swatch-preview-window').removeAttr('style');

				    }
				}, '.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")'); //pass the element as an argument to .on

				$(document).on('click','.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")', function() {
					$(this).closest('.ysw-swatch-options').find('ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
					$(this).addClass('selected');
					var position = Number($(this).data('position'));

					var swatch_position = $(this).closest('.ysw-swatch-options').data('position');
					eval('var this_dropdown = yswSO.settings.swatch_dropdown_' + swatch_position);
					eval('this_swatch_data = yswSO.settings.swatch_data_' + swatch_position);

					this_dropdown.val(this_swatch_data[position].option_val).trigger('change');
                  	this_dropdown[0].dispatchEvent(new Event('change'));
                })

			}

			$(document).on('click','.ysw-swatch-options ul.swatches li.view-more', function() {
				$(this).closest('.ysw-swatch-options').toggleClass('view-all-swatches');
			})


      /* Code commented as the Request FREE Swatches button has a specific link into it and this was an important theme funcionality
      $(document).on('click','.ysw-swatch-options ul.swatches li.free-swatch-button', function() {
				if($(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").is(':visible')) {
					$(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").trigger('click');
				} else {

					$('.ysw-swatch-options .request-free-swatch-link a.mobile-swatch-link').trigger('click');

				}
      }); */

			$(document).on('change', '.bold_option_element select', function() {

				// if ysw_so_position is defined
				// then it's a color swatch related dropdown

				if($(this).data('ysw_so_position') || $(this).data('ysw_so_position') == 0) {

					var select_val = $(this).val();

					var position = $(this).data('ysw_so_position');

					eval('var swatch_data_arr = yswSO.settings.swatch_data_' + position);

					swatch_data_arr.forEach(function(swatch,index) {

						if(swatch.option_val == select_val) {
							var selected_swatch_li = $('.ysw-swatch-options[data-position="' + position + '"] ul.swatches li[data-position="' + index + '"]');
							$('.ysw-swatch-options[data-position="' + position + '"] ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
							selected_swatch_li.addClass('selected');
						}

					})

				}

			})

		},
		build_html: function() {

			var swatch_type_class = '';

			if(yswSO.settings.swatch_type == 'leather-swatch-main' || yswSO.settings.swatch_type == 'leather-swatch') {

				swatch_type_class = 'leather';

			} else if(yswSO.settings.swatch_type == 'fabric-swatch-main') {

				swatch_type_class = 'fabric-main';

			}else if(yswSO.settings.swatch_type == 'fabric-swatch') {

				swatch_type_class = 'fabric';

			}else if(yswSO.settings.swatch_type == 'kfi-fabric-swatch') {

				swatch_type_class = 'fabric';

			}

			var html = '<div class="ysw-swatch-options-wrapper ' + swatch_type_class + '">';

			// Loop through each option
			yswSO.settings.option_names.forEach(function(loop_option, i) {
				eval('var this_swatch_data = yswSO.settings.swatch_data_' + i);

				html += '<div class="ysw-swatch-options" data-position="' + i + '"><div class="swatch-preview-window"><div class="swatch-img"></div><div class="swatch-name"></div></div>';

              // show free swatches on first option
				if(i == 0) {
					html += '<div class="request-free-swatch-link"><a class="desktop-swatch-link" href="' + yswSO.settings.free_swatch_img_desktop + '&utm_source=' + yswSO.settings.swatch_type + '"> </a><a class="mobile-swatch-link"> </a></div>';
				}

				var adjusted_option_name = yswSO.settings.option_names[i].replace('Finish','Finishes').replace('Color','Colors').replace('Type','Types');

				if(freeSwatchFormUrl && i == 0) {
					html += '<div class="swatch-heading swatch-heading--flex">';
					} else {
					html += '<div class="swatch-heading">';
				}

				
                html += this_swatch_data.length + ' ' + adjusted_option_name + ':';

				if(freeSwatchFormUrl && i == 0 && enableFreeSwatchesLink){
				  html += `<a class="btn" target="_blank"  href="${freeSwatchFormUrl}">Request FREE Swatches</a>`;
				}

				html += '</div><ul class="swatches">';

				this_swatch_data.forEach(function(swatch,index) {
					html += '<li data-position="' + index + '"><img src="' + swatch.image_url + '" alt="' + swatch.name + '"></li>';

				})

				// show view more if length is greater than 15 (needs to match css nth-child hide)
				if(this_swatch_data.length > 15) {
					html += '<li class="view-more"><div class="view-more-inner"><span></span></div></li>';
					if(freeSwatchFormUrl && i == 0) {
						html +=  `<li class="free-swatch-button"><div class="free-swatch-inner"><a target="_blank"  href="${freeSwatchFormUrl}">Request FREE Swatches</a></div></li> `;
					} else {
						html += '<li class="free-swatch-button"><div class="free-swatch-inner">Request FREE Swatches</div></li>';
					}
				}

				html += '</ul></div>';

			});

			html += '</div>';

			// $(html).insertBefore('.bold_options');
            $(html).appendTo('#bold_options_swatcher')
		},
		go: function() {

			// clean up img_cdn_url
			yswSO.settings.img_cdn_url = 'https:' + yswSO.settings.free_swatch_img_desktop;
			yswSO.settings.img_cdn_url = yswSO.settings.img_cdn_url.match(/.+?(?=swatch-popup-2019-desktop)/g)[0];

			function check_bold_loaded() {

				if($('.bold_options .bold_option_title').length > 0) {

					clearInterval(check_bold_timer);

					// check for options and push into yswSO.settings.option_names
					switch (yswSO.settings.swatch_type) {
						case 'leather-swatch-main':
							yswSO.settings.option_names.push('Leather Color');
							break;
						case 'leather-swatch':
							yswSO.settings.option_names.push('Leather Color');
							break;
						case 'fabric-swatch-main':
							yswSO.settings.option_names.push('Fabric Color');
							break;
						case 'fabric-swatch':
							yswSO.settings.option_names.push('Fabric Color');
                        	break;
						case 'kfi-fabric-swatch':
							yswSO.settings.option_names.push('Fabric Color');
					}
					if($('.bold_options select[name="properties[Seat Type]"]').length > 0) {
						yswSO.settings.option_names.push('Seat Type');
					}
					if($('.bold_options select[name="properties[Leg Finish]"]').length > 0) {
						yswSO.settings.option_names.push('Leg Finish');
					}
					if($('.bold_options select[name="properties[Nail Trim Color]"]').length > 0) {
						yswSO.settings.option_names.push('Nail Trim Color');
					}

					yswSO.settings.option_names.forEach(function(loop_option, i) {

						$('.bold_options .bold_option_title').each(function() {

							var label = $(this).text().trim();

							if(loop_option.toLowerCase() == label.toLowerCase()) {
								//console.log('yswSO label match!')

								var select_dropdown = $(this).closest('label').find('>.bold_option_element select');

								select_dropdown.data('ysw_so_position', i);

								eval('yswSO.settings.swatch_dropdown_' + i + '= select_dropdown');

								eval('yswSO.settings.swatch_data_' + i + ' = []');

								select_dropdown.find('option').each(function(index) {

									// skip first option
									if(index > 0) {

										var option_name = $(this).text().trim();

										var option_val = $(this).val();

	  									var price_change = option_name.match(/\[.+\]/g);

	  									//console.log(option_name);

	  									var price;

	  									if(price_change) {
	  										//console.log(price_change[0]);
	  										price = price_change[0].match(/\d+.\d{2}/g)[0];
	  										//console.log(price);
	  										option_name = option_name.replace(/\[.+\]/g,'').trim();
	  									} else {
	  										price = 0;
	  									}

	  									var image_url = yswSO.settings.img_cdn_url + option_name.replace(/\s/g,'-') + '.jpg?d=june21';

	  									//console.log('trimmed: ' + option_name);

	  									var swatch_data_option = {
	  										name: option_name,
	  										price_upcharge: Number(price),
	  										image_url: image_url,
	  										option_val: option_val
	  									}

	  									eval('yswSO.settings.swatch_data_' + i + '.push(swatch_data_option)');

									}

								})

								return false;

							}

						});

					});

					yswSO.build_html();
					yswSO.custom_events();

				}

			}

			var check_bold_timer = setInterval(check_bold_loaded, 1000);

		}
	}
})(jQuery)
